import Vue from "vue";
let baseUrl = process.env.VUE_APP_URL;

export default {
  registerUser(type, user) {
    let axiosConfig = {
      headers: {
        "Application-Type": "Web"
      }
    };
    return Vue.axios.post(`Account/register`, user, axiosConfig)
  },
  registerClient({commit}, user) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(user);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    return fetch(`${baseUrl}Client/register`, requestOptions)
        .then(result => {
          commit('AUTHORIZATION', result);
          return result;
        })
        .catch(() => null);
  },
  registerManually(type, user) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Content-Type" : "application/json",
        "Authorization": `Bearer ${token}`
      }
    };

    let data = JSON.stringify(user)

    return Vue.axios.post(`Client/register-manually`, data, axiosConfig )
  },
  loginUser({commit}, user) {
    return Vue.axios.post(`Account/login`, user)
      .then(response => {
        if (response.data.statusCode === 200) {
          commit('AUTHORIZATION', response.data.result);
          commit('SET_USER_ROLES', response.data.result.roles);
        } else {
          commit('AUTHORIZATION', []);
          commit('SET_USER_ROLES', []);
        }

        return response;
      });
  },
  getUser({commit}, val) {
    let token  = localStorage.getItem('token');
    return Vue.axios
        .get(`User/profile`,
            {
              headers: {
                "Authorization": `Bearer ${val ? val : token}`
              }
            })
        .then(res => {
          commit('SET_USER', res.data.result);
          commit('SET_LOGO', res.data.result.logoUrl);
          commit('SET_AVATAR_IMG', res.data.result.avatarUrl);
          return res
        })
        .catch(() => null);
  },
  getReferrals({commit}, data) {
    let token  = localStorage.getItem('token');
    return Vue.axios
        .get(`User/referrals?limit=${data.limit}&page=${data.page}`,
            {
              headers: {
                "Authorization": `Bearer ${token}`
              }
            })
        .then(res => {
          commit('SET_REFERRALS', res.data.result)
        })
        .catch(() => []);
  },
  getNotifications({commit}) {
    let token  = localStorage.getItem('token');
    return Vue.axios
        .get(`Notification/notifications`,
            {
              headers: {
                "Authorization": `Bearer ${token}`
              }
            })
        .then(res => {
          commit('SET_NOTIFICATIONS', res.data.result)
        })
        .catch(() => []);
  },
  uploadAvatar({commit}, file) {
    let token  = localStorage.getItem('token');

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    let formData = new FormData();
    formData.append('FileData', file.FileData);
    formData.append('FileName', file.FileName);

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    return Vue.axios.post("User/upload-avatar", formData, axiosConfig ).then((res) => {
      commit('SET_AVATAR_IMG', res.data.model);
      return res;
    }).catch((err) => {
      return err
    })
  },
  uploadTracImage({commit}, file) {
    let token  = localStorage.getItem('token');

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var formdata = new FormData();
    formdata.append("FileData", file.FileData);
    formdata.append("FileName", file.FileName);
    formdata.append("Id", file.Id);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    commit('SET_POST_COMMIT', 'done');

    var imageUpload = process.env.VUE_APP_URL + "Trac/upload-image";
    return fetch(imageUpload, requestOptions)
  },
  uploadLogo({commit}, file) {
    let token  = localStorage.getItem('token');

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    let formData = new FormData();
    formData.append('FileData', file.FileData);
    formData.append('FileName', file.FileName);

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    return Vue.axios.post("User/upload-logo", formData, axiosConfig ).then((res) => {
      commit('SET_LOGO', res.data.model);
      return res;
    }).catch((err) => {
      return err
    })
  },
  updateProfile({commit}, user) {
    let token  = localStorage.getItem('token');
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(user);

    var requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    return fetch(`${baseUrl}User/update-profile`, requestOptions)
        .then(response => {
          if (response.status === '200') {
            commit('UPDATE_PROFILE', response);
            return response.text()
          } else {
            commit('UPDATE_PROFILE', []);
            return response
          }
        })
        .catch(() => null);
  },
  deleteUserApi(type, email) {
    let token  = localStorage.getItem('token');
    return Vue.axios
      .delete(`User/${email}`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${token}`
          }
        })
  },
  getTracs({commit}, payload) {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    const urlParams = new URLSearchParams(payload).toString();

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.get(`/Trac/get?${urlParams}`, axiosConfig);
  },
  getTracByUserId({commit}, id) {
    let token  = localStorage.getItem('token');
    return Vue.axios
      .get(`UserTrac/${id}`,
          {
            headers: {
              "Authorization": `Bearer ${token}`
            }
          })
      .then(res => {
        if (res.data.model) {
          commit('SET_TRAC', res.data.model.enrolledTracs)
        } else {
          commit('SET_TRAC', [])
        }
      })
      .catch(() => commit('SET_TRAC', []));
  },
  getTracById({commit}, id) {
    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        IncludeSubRelations: true
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.get(`/Trac/get/${id}`, axiosConfig);
  },
  createTrac({commit}, payload) {
    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.post(`/Trac/create`, payload, axiosConfig)
  },
  updateTrac({commit}, payload) {
    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.put(`Trac/update/${payload.id}`, payload, axiosConfig)
  },
  getUserTracById({commit}, data ) {
    let token  = localStorage.getItem('token');
    return Vue.axios
      .get(`/UserTrac/by-id?tracId=${data.tracId}&clientId=${data.clientId}`,
          {
            headers: {
              "Authorization": `Bearer ${token}`
            }
          })
      .then(res => {
        commit('SET_GOAL', res.data.model[0])
      })
      .catch(() => []);
  },
  getMilestones({commit}, id) {
    let token  = localStorage.getItem('token');
    return Vue.axios
      .get(`Milestone/get-by-goalId?goalId=${id}`,
          {
            headers: {
              "Authorization": `Bearer ${token}`
            }
          })
      .then(res => {
        commit('SET_MILESTONE', res.data.result)
      })
      .catch(() => []);
  },
  getCalendar({commit}, id) {
    let token  = localStorage.getItem('token');
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    return Vue.axios
      .post(`Calendar/preview?startDate=${month}-1-${year}&tracId=${id}`,{
        startDate: `${month}-1-${year}`,
        tracId:'2e37e1fb-fa0c-4efc-453c-08d8f81fa6a2'
      },
      {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      })
      .then(res => {
        commit('SET_CALENDAR', res.data.model)
      })
      .catch(() => []);
  },
  addGoal({commit}, goalData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');
    return Vue.axios.post(`/Goal/create`, goalData, axiosConfig )
  },
  editGoal({commit}, goalData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');
    return Vue.axios.put(`/Goal/update-goal`, goalData, axiosConfig )
  },
  addMilestones({commit}, milestonesData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');
    return Vue.axios.post(`/Milestone/create`, milestonesData, axiosConfig )
  },
  editMilestones(type, milestoneData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    return Vue.axios.put(`/Milestone/update-milestone`, milestoneData, axiosConfig )
  },
  editUserMilestones(type, milestoneData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    return Vue.axios.post(`/UserMilestone/update`, milestoneData, axiosConfig )
  },
  getTasks({commit}, payload) {
    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.get(`/Task/get-by-milestone/${payload.milestoneId}`, axiosConfig);
  },
  getPreviousTasks({commit}, payload) {
    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.get(`/Task/get-previous-tasks/${payload.milestoneId}`, axiosConfig);
  },
  createTask({commit}, Taskdata) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');
    return Vue.axios.post(`/Task/create`, Taskdata, axiosConfig )
  },
  editTask({commit}, taskData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');
    return Vue.axios.put(`/Task/update-task`, taskData, axiosConfig )
  },
  editUserTask(type, taskData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    return Vue.axios.post(`/UserTask/update`, taskData, axiosConfig )
  },
  copyTrac({commit}, tracData) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');

    let data = {
      id: tracData.id
    };

    return Vue.axios.post(`/Trac/create-copy`, data, axiosConfig )
  },
  copyMilestone({commit}, item) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');

    let data = {
      id: item.uid
    };

    return Vue.axios.post(`/Milestone/create-copy`, data, axiosConfig )
  },
  copyTask({commit}, item) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');

    let data = {
      id: item.id
    };

    return Vue.axios.post(`/Task/create-copy`, data, axiosConfig )
  },
  getAspiration({commit}) {
    let token  = localStorage.getItem('token');
    return Vue.axios
      .get(`/Trac/aspiration`,
        {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
      .then(res => {
        commit('SET_ASPIRATION', res.data.model)
      })
      .catch(() => {
        commit('SET_ASPIRATION', [])
      });
  },
  getAuthorsDropdown() {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    return Vue.axios.get(`/Author/get-dropdown`, axiosConfig);
  },
  passwordResetRequest(type, email) {
    return Vue.axios.get(`/Account/password-reset/request?email=${email}` )
  },
  resetPassword(type, user) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ARRAffinity=f77cdac399392a2dbbc2d618001a862ad3841be56d8b6786390f03aee49e7f0f; ARRAffinitySameSite=f77cdac399392a2dbbc2d618001a862ad3841be56d8b6786390f03aee49e7f0f");

    var raw = JSON.stringify(user);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    return fetch(`${baseUrl}/Account/password-reset`, requestOptions);
  },
  getReferralsById(type, id) {
    let token  = localStorage.getItem('token');
    return Vue.axios
      .get(`/User/referrals/${id}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
  },
  deleteTask({commit}, item) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');

    let data = {
      userId: localStorage.getItem('userId'),
      taskId: item.id
    };

    return Vue.axios.post(`/Task/remove`, data, axiosConfig )
  },
  deleteMilestone({commit}, item) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    commit('SET_POST_COMMIT', 'done');

    let data = {
      userId: localStorage.getItem('userId'),
      milestoneId: item.uid
    };

    return Vue.axios.post(`/Milestone/remove`, data, axiosConfig)
  },
  deleteTrac({commit}, payload) {
    const token = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.delete(`/Trac/remove/${payload.id}`, axiosConfig)
  },
  subscribeTier(type, item) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    let data = {
      userId: item,
      subscriptionTier: 1
    }


    return Vue.axios.post(`/Account/subscribe-tier`, data, axiosConfig )
  },
  stripeCheckoutLink(type, payload) {
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };


    return Vue.axios.post(`/Payment/stripe-checkout-link`, payload, axiosConfig )
  },
  async getMetrics({commit}, payload) {
    commit('SET_METRICS_LOADING', true)
    let token  = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      },
    };

    if (payload) {
      axiosConfig.params = payload
    }

    let data = await Vue.axios.get(`/Dashboard/get-metrics`, axiosConfig );
    if (data.status === 200) {
      commit('SET_METRICS', data.data.model)
      commit('SET_METRICS_ERROR', false)
    } else {
      commit('SET_METRICS', [])
      commit('SET_METRICS_ERROR', true)
    }
    commit('SET_METRICS_LOADING', false)
  },
  getCategories({commit}, payload) {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    const urlParams = new URLSearchParams(payload).toString();

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.get(`/Category/get?${urlParams}`, axiosConfig);
  },
  getCategoriesDropdown() {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    return Vue.axios.get(`/Category/get-dropdown`, axiosConfig);
  },
  createCategory({commit}, payload) {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.post(`/Category/create`, payload, axiosConfig)
  },
  updateCategory({commit}, payload) {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.put(`/Category/update/${payload.id}`, payload, axiosConfig);
  },
  deleteCategory(type, payload) {
    const token = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    return Vue.axios.delete(`/Category/remove/${payload.id}`, axiosConfig);
  },
  getTaskResources({commit}, taskId) {
    const token = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.get(`/TaskResource/get-by-task/${taskId}`, axiosConfig);
  },
  createTaskResource({commit}, payload) {
    const token = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.post(`/TaskResource/create`, payload, axiosConfig);
  },
  updateTaskResource({commit}, payload) {
    const token = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.put(`/TaskResource/update/${payload.id}`, payload, axiosConfig);
  },
  deleteTaskResources({commit}, taskResourceId) {
    const token = localStorage.getItem('token');

    const axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    commit('SET_POST_COMMIT', 'done');

    return Vue.axios.delete(`/TaskResource/remove/${taskResourceId}`, axiosConfig);
  },
  activateCategory(type, payload) {
    const token = localStorage.getItem('token');

    let axiosConfig = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };

    return Vue.axios.post(`/Category/restore/${payload.id}`, null, axiosConfig);
  }
}
